// Generated by scripts/build-ui-icons.mjs.
export { Sparkle as default } from "../ui/glyphs-7";
